<template>
    <div
        class="text-body-sm xl:text-body-md font-bold"
        :class="[activeCycle === 'yearly' ? 'text-orange-400' : ' text-gray-100']"
    >
        {{ symbol }}{{ amountPerPhotos }}/Photo
    </div>
</template>

<script setup lang="ts">
interface IProps {
    symbol: string;
    amountPerPhotos: string;
}
const props = defineProps<IProps>();

const { activeCycle } = storeToRefs(usePricingStore());
</script>
